import { IntlProvider } from 'react-intl';
import { useAtomValue } from 'jotai';
import { localeAtom } from '../../state/localeState';
import Messages from '../../intl/Messages';
import MessagesEN from '../../intl/MessagesEN';
import { type ReactNode } from 'react';

const messagesByLocale: Record<'fr' | 'en', Record<string, string>> = {
  fr: Messages,
  en: MessagesEN,
};

export function LocaleProvider({ children }: { children: ReactNode }) {
  const locale = useAtomValue(localeAtom);
  const messages = messagesByLocale[locale];

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="fr">
      {children}
    </IntlProvider>
  );
}
